import { TBaseIcon } from '@/shared/assets/icons/base-icon/base-icon.types';
import { AssetTypeEnum } from '@/shared/types/types.generated';

export type TResourceIconProps = {
  resourceType: ResourceTypeEnum | AssetTypeEnum;
  iconProps?: TBaseIcon;
};

export enum ResourceTypeEnum {
  Ideaas = 'IDEAAS',
  Device = 'DEVICE',
  Document = 'DOCUMENT',
  Gateway = 'GATEWAY',
  Workstation = 'WORKSTATION',
  Project = 'PROJECT',
  Vault = 'VAULT',
  Secret = 'SECRET',
  Identity = 'IDENT',
  Integration = 'INTEGRATION',
  Group = 'GROUP',
  Pipeline = 'PIPELINE',
  Webhook = 'WEBHOOK',
  License = 'LICENSE',
  Offboarding = 'OFFBOARDING',
  Tag = 'TAG',
  AuditLog = 'AUDIT_LOG',
  Vulnerabilities = 'VULNERABILITIES',
  CustomField = 'CUSTOM_FIELD',
  Notification = 'NOTIFICATIONS',
  BackofficeUser = 'backofficeUser',
  BackofficeUserRole = 'backofficeUserRole',
  BackofficeGroup = 'backofficeGroup',
  BackofficeTenant = 'backofficeTenant',
}

export enum AggregationTypeEnum {
  Tag = 'TAG',
  Group = 'GROUP',
  Id = 'ID',
}
